import React from 'react';
import NinjaGame from '../NinjaGame';
import { ALL_DRILLS } from '../DrillConstants';

const TwentyFiveYardShot = () => {
    const idx = ALL_DRILLS.findIndex(d => d.id === '25yard');
    return <NinjaGame initialDrillIndex={idx} />;
};

export default TwentyFiveYardShot;
